import { IC, Avatar, Stars, Pill, VerifiedBadge } from "../shared";

// ── Premium Trip Card ────────────────────────────────────────────────────────
const TripCard = ({ trip, myReq, onClick, partial, idx = 0 }) => {
  const driver = { id: trip.driverId, name: trip.driverName, avatar: trip.driverAvatar, rating: trip.driverRating || 0 };
  const seatsLeft = trip.seats - (trip.passengers?.length || 0);
  const dt = new Date(trip.datetime);
  const priceParts = trip.price.toString().split(".");
  const euros = priceParts[0];
  const cents = priceParts[1] ? `.${priceParts[1].padEnd(2, "0")}` : ".00";

  return (
    <div onClick={onClick} className="igo-trip-card acard" style={{ animationDelay: `${idx * 50}ms` }}>
      {/* Route + Price */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
            <span style={{ width: 10, height: 10, borderRadius: "50%", background: "var(--accent)", flexShrink: 0, boxShadow: "0 0 0 3px rgba(43,91,224,.15)" }}/>
            <span style={{ fontFamily: "Syne", fontWeight: 700, fontSize: 14, color: "var(--ink)" }}>{trip.from}</span>
          </div>
          <div style={{ width: 1.5, height: 14, background: "var(--border)", marginLeft: 4, marginBottom: 6 }}/>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ width: 10, height: 10, borderRadius: 3, background: "var(--accent2)", flexShrink: 0, boxShadow: "0 0 0 3px rgba(43,91,224,.15)" }}/>
            <span style={{ fontFamily: "Syne", fontWeight: 700, fontSize: 14, color: "var(--ink)" }}>{trip.to}</span>
          </div>
        </div>
        {/* Split price */}
        <div style={{ textAlign: "right", flexShrink: 0, marginLeft: 16 }}>
          <div style={{ fontFamily: "Syne", fontWeight: 800, fontSize: 24, color: "var(--accent)", lineHeight: 1, fontVariantNumeric: "tabular-nums" }}>
            €{euros}<span style={{ fontSize: 14, fontWeight: 700, opacity: .7 }}>{cents}</span>
          </div>
          <div style={{ fontSize: 10, color: "var(--muted)", fontWeight: 600, marginTop: 2 }}>per seat</div>
        </div>
      </div>

      {/* Driver */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, borderTop: "1px solid var(--border)", paddingTop: 12 }}>
        <Avatar user={driver} size={36}/>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, fontSize: 13, color: "var(--ink)", display: "flex", alignItems: "center", gap: 5 }}>
            {driver.name}
            {driver.rating >= 4.5 && <VerifiedBadge size={14}/>}
          </div>
          <Stars rating={driver.rating} size={10}/>
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 2 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 4, color: "var(--muted)", fontSize: 11 }}>
            <span style={{ width: 10, height: 10 }}>{IC.clock}</span>
            {dt.toLocaleTimeString("en", { hour: "2-digit", minute: "2-digit" })}
          </div>
          <div style={{ fontSize: 11, color: "var(--muted)" }}>{dt.toLocaleDateString("en", { month: "short", day: "numeric" })}</div>
        </div>
      </div>

      {/* Pills */}
      <div style={{ display: "flex", gap: 6, marginTop: 10, flexWrap: "wrap" }}>
        {seatsLeft > 0
          ? <Pill color="var(--success)">{seatsLeft} seat{seatsLeft !== 1 ? "s" : ""} left</Pill>
          : <Pill color="var(--muted)" bg="var(--warm)">Full</Pill>}
        {myReq && (
          <Pill color={myReq.status === "accepted" ? "var(--success)" : myReq.status === "rejected" ? "#c0392b" : "var(--accent2)"}>
            {myReq.status}
          </Pill>
        )}
        {partial && <Pill color="var(--accent2)">Check route</Pill>}
      </div>
    </div>
  );
};

export default TripCard;
